import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {settingsEmail, settingsOtherPlans} from "store/reducer/user/settings/selectors";
import Title from "features/components/title";
import {__} from "services/i18n";
import {Switch} from "features/components/switch";
import {setProfileSettingsStart} from "store/reducer/user/settings/reducer";
import {getUserSubscriptionStart} from "store/reducer/user/subscription/reducer";
import {getUserSubscriptionType} from "store/reducer/user/subscription/selectors";
import {SUBSCRIPTION_TYPES} from "constants.js";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: settingsEmail(state),
    otherPlans: settingsOtherPlans(state),
    sub_type: getUserSubscriptionType(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    setProfileSettingsStart,
    getUserSubscriptionStart
};

export const SettingsEmail = (props) => {
    const {data, setProfileSettingsStart, getUserSubscriptionStart, otherPlans, sub_type} = props;

    React.useEffect(() => {
        getUserSubscriptionStart();
    }, [getUserSubscriptionStart]);

    const onChange = useCallback((key, status) => {
        setProfileSettingsStart({key, value: status});
    }, [setProfileSettingsStart]);


    return <div className="email-settings">
        <Title size={18}>{__("settings.tabs.settings.subtitle")}</Title>
        {data.map(i => <Switch key={i.key} title={__(`settings.tabs.settings.${i.key}`)} status={i.value} onChange={(val) => onChange(i.key, val)}/>)}
        <Title size={18}>{__("settings.tabs.settings.other_plans")}</Title>
        {otherPlans.map(i => <Switch key={i.key} title={__(`settings.tabs.settings.${[SUBSCRIPTION_TYPES.OsaKnight, SUBSCRIPTION_TYPES.OsaKnightExclusive].includes(sub_type) ? "knight" : "circle"}.${i.key}`)} status={i.value} onChange={(val) => onChange(i.key, val)}/>)}
    </div>
}
export default connect(mapStateToProps, mapDispatchToProps)(SettingsEmail);
